import React, { useState } from 'react';
import { Radio } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';

const OVERLAYS = [
    { value: 'wind', label: 'Vento', icon: '💨' },
    { value: 'rain', label: 'Chuva', icon: '🌧️' },
    { value: 'clouds', label: 'Nuvens', icon: '☁️' },
    { value: 'temp', label: 'Temp.', icon: '🌡️' },
    { value: 'pressure', label: 'Pressão', icon: '🔵' },
];

const WeatherMap = ({ latitude, longitude, siteName, locationName, height = 480 }) => {
    const [overlay, setOverlay] = useState('wind');

    const lat = latitude != null ? Number(latitude) : -22.9068;
    const lon = longitude != null ? Number(longitude) : -43.1729;

    const validLat = !isNaN(lat) && lat !== 0 ? lat : -22.9068;
    const validLon = !isNaN(lon) && lon !== 0 ? lon : -43.1729;

    const windyUrl = [
        'https://embed.windy.com/embed2.html',
        `?lat=${validLat.toFixed(4)}`,
        `&lon=${validLon.toFixed(4)}`,
        `&detailLat=${validLat.toFixed(4)}`,
        `&detailLon=${validLon.toFixed(4)}`,
        '&zoom=11',
        '&level=surface',
        `&overlay=${overlay}`,
        '&product=ecmwf',
        '&menu=',
        '&message=true',
        '&marker=true',
        '&calendar=now',
        '&pressure=true',
        '&type=map',
        '&location=coordinates',
        '&detail=true',
        '&metricWind=km%2Fh',
        '&metricTemp=%C2%B0C',
        '&radarRange=-1',
    ].join('');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {/* Seletor de overlay */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '12px', color: '#8c8c8c', fontWeight: 500 }}>Visualizar:</span>
                <Radio.Group
                    value={overlay}
                    onChange={(e) => setOverlay(e.target.value)}
                    size="small"
                    buttonStyle="solid"
                    optionType="button"
                >
                    {OVERLAYS.map(o => (
                        <Radio.Button key={o.value} value={o.value} style={{ fontSize: '12px' }}>
                            {o.icon} {o.label}
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </div>

            {/* Localização */}
            {siteName && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#595959', fontSize: '12px' }}>
                    <EnvironmentOutlined style={{ color: '#1890ff' }} />
                    <span><strong>{siteName}</strong>{locationName ? ` — ${locationName}` : ''}</span>
                    <span style={{ color: '#bfbfbf' }}>
                        ({validLat.toFixed(4)}°, {validLon.toFixed(4)}°)
                    </span>
                </div>
            )}

            {/* Mapa Windy */}
            <div style={{
                height: `${height}px`,
                width: '100%',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid #e8e8e8',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            }}>
                <iframe
                    key={`${validLat}-${validLon}-${overlay}`}
                    title={`Windy – ${siteName || 'Mapa Meteorológico'}`}
                    src={windyUrl}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allow="fullscreen"
                    style={{ border: 'none', display: 'block' }}
                />
            </div>

            <div style={{ fontSize: '11px', color: '#bfbfbf', textAlign: 'right' }}>
                Powered by <a href="https://www.windy.com" target="_blank" rel="noreferrer" style={{ color: '#bfbfbf' }}>Windy.com</a>
            </div>
        </div>
    );
};

export default WeatherMap;
